import { useIsLearningCenter } from "~/hooks/learning-center/use-is-learning-center";
import useLearningCenterConsent from "~/hooks/learning-center/use-learning-center-consent";

import BuilderTpaLearningCenterConsent from "./index";

/**
 * Mount-site guard for the TPA Learning Center consent modal (SFCC-11508).
 *
 * Mounted globally in the app layout so it can show on every Builder-rendered
 * surface AND the Workers-served LC routes; the render is gated by ROUTE
 * detection (`useIsLearningCenter`), not by which page mounted it.
 *
 * Trigger (COM-504): the modal fires ONLY when both `employer_id` and
 * `employee_id` are on the current URL. It previously keyed off the `c_TPA`
 * profile attribute (ported from the composable `Page.jsx`), which prompted
 * every TPA shopper — the business rejected that. The params are not persisted,
 * so navigating away drops them and the modal no longer qualifies; that is
 * accepted behavior. Key spellings (case-insensitive, mirroring SFRA's SSO
 * mapping — `employerId`, `employee-id`, …) live in `~/hec/tpa/lc-consent.logic`.
 *
 * `hasRespondedtoConsentModal()` reads the localStorage answer so the modal
 * renders at most once per browser.
 */
export function TpaLearningCenterConsentGate() {
  const isLearningCenter = useIsLearningCenter();
  const { hasRespondedtoConsentModal, hasEmployerUrlParams } =
    useLearningCenterConsent();

  if (
    !isLearningCenter ||
    !hasEmployerUrlParams() ||
    hasRespondedtoConsentModal()
  ) {
    return null;
  }

  return <BuilderTpaLearningCenterConsent />;
}
